import React, { FC, ReactElement } from 'react';
import { FormikActions } from 'formik';

import { WizardPage } from 'buyside/components/presentation/Form/Wizard/Wizard';
import ProApplicationSubmission from './ProApplicationSubmission';
import { WizardContextProps } from 'interfaces/wizard/wizard';
import { applicationSubmissionSchema } from 'buyside/components/presentation/UserApplication/Helpers/validations';

import { ApplicationFormValues } from 'interfaces/userApplication/userApplication';
export type PASCProps = {
  email: string;
  handleSubmit: (
    values: ApplicationFormValues,
    setTouched: FormikActions<ApplicationFormValues>['setTouched'],
    setSubmitting: FormikActions<ApplicationFormValues>['setSubmitting'],
    next: WizardContextProps['next']
  ) => void;
  isLoading: boolean;
  isRobot: boolean;
};

const ProApplicationSubmissionContainer: FC<PASCProps & {
  validationSchema: typeof applicationSubmissionSchema;
}> = ({ validationSchema, isLoading, isRobot, email, handleSubmit }): ReactElement => (
  <WizardPage validationSchema={validationSchema}>
    {({
      values,
      touched,
      errors,
      setTouched,
      setSubmitting,
      next
    }: WizardContextProps): ReactElement => {
      return (
        <ProApplicationSubmission
          email={email}
          errors={errors}
          handleSubmit={handleSubmit}
          isLoading={Boolean(isLoading)}
          isRobot={Boolean(isRobot)}
          setTouched={setTouched}
          setSubmitting={setSubmitting}
          next={next}
          touched={touched}
          values={values}
        />
      );
    }}
  </WizardPage>
);

export default ProApplicationSubmissionContainer;
